import React from "react";
import { DealInfoForm } from "./BaseDealInfoForm";
import type { DealInfoFormProps } from "./BaseDealInfoForm";
import { creationTestIds } from "./utils";
import Box from "@/ui/atoms/Box";
import FormSteps from "./FormSteps";

export type CreateDealInfoFormProps = Omit<DealInfoFormProps, "children"> & {
    onBack: () => void;
};

export const CreateDealInfoForm: React.FC<CreateDealInfoFormProps> = props => {
    return (
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
            <Box
                sx={{
                    fontSize: "1.2rem",
                    fontWeight: "500",
                    margin: "3rem 0 2rem 0",
                    textAlign: "center",
                }}
                data-testid={creationTestIds.dealInfoFormTitle}
            >
                Create a Project
            </Box>
            <DealInfoForm {...props} requireDirtyForSubmit={false}>
                {({ onSubmit, isSubmitDisabled }) => (
                    <FormSteps
                        onNext={onSubmit}
                        isNextDisabled={isSubmitDisabled}
                        currentStep={1}
                        totalSteps={2}
                        editingProperty={false}
                        onBack={props.onBack}
                        useSubNavbarIds={false}
                    />
                )}
            </DealInfoForm>
        </Box>
    );
};
